import AppMenu from './app-menu';

export default class LayoutController {
    constructor() {
        this.appMenu = AppMenu;
        this.navCollapsed = false;
    }

    $onInit() {
        this.isMobileNav = null;
    }

    showMobileNav() {
        this.isMobileNav = true;
    }

    hideMobileNav() {
        this.isMobileNav = false;
    }

    onNavToggle(isCollapsed) {
        this.navCollapsed = isCollapsed;
    }

    get isNavCollapsed() {
        return this.navCollapsed;
    }
}



// WEBPACK FOOTER //
// ./app/common/layout/layout.controller.js